/**
 * BarraPrueba — franja AMARILLA superior visible cuando la empresa está en
 * período de PRUEBA (estado del plan TronIA): avisa el consumo y lleva a la
 * página de pago de la suscripción. Se consulta el mismo endpoint del panel
 * TronIA (/tronia/estado) — sin estado nuevo.
 */

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons'
import { api } from '../api/client'

interface TroniaEstadoBarra {
  estado?: string
  planNombre?: string
  consultasUsadas?: number
  consultasPlan?: number
  /** [RGM] 2026-09-17: estado de la EMPRESA (6 = en prueba) — la barra se
   *  muestra SOLO con la empresa en prueba y desaparece al activarse. */
  empresaEstado?: number
}

const BarraPrueba: React.FC = () => {
  const [estado, setEstado] = useState<TroniaEstadoBarra | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    api.get<TroniaEstadoBarra>('/tronia/estado')
      .then(setEstado)
      .catch(() => {})
  }, [])

  // [RGM] 2026-09-17 (reporte Rafael: "la empresa está activada y sigue la
  // barra amarilla"): la barra es del período de PRUEBA DE LA EMPRESA
  // (estado 6) — al activarse la empresa desaparece. (Antes miraba el estado
  // del plan TronIA y por eso seguía con la empresa activa.)
  if (!estado || Number(estado.empresaEstado) !== 6) return null

  return (
    <div
      className="d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2 mb-3"
      style={{
        background: '#FFC107',
        color: '#3a2e00',
        borderRadius: 8,
        fontSize: 13,
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <CIcon icon={cilWarning} />
        <span>
          <strong>Período de PRUEBA</strong> — Consultas TronIA:{' '}
          {estado.consultasUsadas ?? 0} / {estado.consultasPlan ?? 0} ·{' '}
          Suscríbete para mantener el servicio sin interrupciones.
        </span>
      </div>
      {/* [RGM] Reconexión de la pantalla de pago: la franja lleva a /pago
          (antes iba a /mi-cuenta#tronia y dejó huérfana a PagoPage). */}
      <CButton size="sm" color="dark" onClick={() => navigate('/pago')}>
        Pagar suscripción
      </CButton>
    </div>
  )
}

export default BarraPrueba
